import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/Tabs';
import {
  MARKETING_RANGE_OPTIONS,
  type MarketingRange,
} from '@/features/marketing/range';

interface RangeSelectorProps {
  value: MarketingRange;
  onChange: (range: MarketingRange) => void;
}

/**
 * Date-range segmented control for the Marketing Dashboard.
 *
 * Radix `Tabs` is the only segmented control in the design system, so — as on
 * the Web Analytics page — we use it purely as a control and keep the selected
 * range in the caller's state. The empty `TabsContent` nodes exist because
 * Radix needs a matching content node per trigger to manage focus cleanly.
 */
export function RangeSelector({ value, onChange }: RangeSelectorProps) {
  return (
    <Tabs value={value} onValueChange={(next) => onChange(next as MarketingRange)}>
      <TabsList>
        {MARKETING_RANGE_OPTIONS.map((option) => (
          <TabsTrigger key={option.id} value={option.id}>
            {option.label}
          </TabsTrigger>
        ))}
      </TabsList>
      {MARKETING_RANGE_OPTIONS.map((option) => (
        <TabsContent key={option.id} value={option.id} className="hidden" />
      ))}
    </Tabs>
  );
}

/** Comparison caption for metric deltas, e.g. "vs prior 28 days". */
export function comparisonLabel(range: MarketingRange): string {
  const option = MARKETING_RANGE_OPTIONS.find((o) => o.id === range);
  const days = option ? Number.parseInt(option.shortLabel, 10) : 28;
  return `vs prior ${days} days`;
}
